import { FC, useState } from 'react'
//components
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { isInViewFooterState, inquiryState, inputState, onetimeKeyState, stepState } from '../../../states/messageState'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { InputAndSubmitButton } from '../InputAndSubmitButton'
import { putUpdateAddress } from '../../../api/contracts'
import { AddressUpdateValue } from '../../../models/contractsModel'

type AddressStepType = keyof AddressUpdateValue['shippingAddress']

export const InputShippingAddress: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const setCurrentStep = useSetRecoilState(stepState)

  const [input, setInput] = useRecoilState(inputState)

  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const inquiry = useRecoilValue(inquiryState)
  const onetimeKey = useRecoilValue(onetimeKeyState)

  const [currentAddressStep, setCurrentAddressStep] = useState<AddressStepType>('postalNumber')

  const [shippingAddressData, setShippingAddressData] = useState<AddressUpdateValue['shippingAddress']>({
    postalNumber: '',
    prefecture: '',
    city: '',
    address: '',
    building: '',
  })

  const handleSubmit = async (nextStepType: AddressStepType, nextMessageTitle: string) => {
    setIsInViewFooter(false)
    await handleAddSenderParent('user', input)
    setInput('')
    setShippingAddressData((prev) => ({ ...prev, [currentAddressStep]: input }))
    await handleAddSenderParent('bot', `${nextMessageTitle}を入力してください`)
    setCurrentAddressStep(nextStepType)
    handleInViewFooter()
  }

  const handleSubmitBuilding = async () => {
    const { contractId } = inquiry
    setIsInViewFooter(false)
    await handleAddSenderParent('user', input || '無し')
    setInput('')

    //住所更新を保証作成より先に行う
    const updatedShippingAddress = { ...shippingAddressData, building: input }
    await putUpdateAddress(
      {
        contractId,
        shippingAddress: updatedShippingAddress,
      },
      onetimeKey
    )

    const { address, building, city, postalNumber, prefecture } = updatedShippingAddress
    await handleAddSenderParent('bot', `こちらの住所に変更致します。`)
    await handleAddMessage('bot', `${postalNumber} ${prefecture} ${city} ${address} ${building}`)
    await handleAddMessage(
      'bot',
      `故障した商品の状態が分かるように画像を3枚までアップロードしてください。\n※JPGまたはPNG\n※画像サイズは15MB以下`
    )
    handleInViewFooter()
    setCurrentStep('uploadImage')
  }

  const inputProps = (): {
    placeholder: string
    handleSubmit: () => Promise<void>
  } => {
    switch (currentAddressStep) {
      case 'postalNumber':
        return {
          placeholder: '1580096',
          handleSubmit: () => handleSubmit('prefecture', '都道府県'),
        }
      case 'prefecture':
        return {
          placeholder: '東京都',
          handleSubmit: () => handleSubmit('city', '市区町村'),
        }
      case 'city':
        return {
          placeholder: '世田谷区玉川台',
          handleSubmit: () => handleSubmit('address', '番地'),
        }
      case 'address':
        return {
          placeholder: '1-3-8',
          handleSubmit: () => handleSubmit('building', '建物名(無しの場合はそのまま送信)'),
        }
      case 'building':
        return {
          placeholder: 'NIXビル4F',
          handleSubmit: handleSubmitBuilding,
        }
    }
  }

  return (
    <FooterContent isWide>
      <InputAndSubmitButton
        value={input}
        placeholder={inputProps().placeholder}
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && inputProps().handleSubmit()}
        onClick={inputProps().handleSubmit}
        isUnUseDisable={currentAddressStep === 'building'}
      />
    </FooterContent>
  )
}
